import {
  BoltOutlined,
  LaunchOutlined,
  LinkOutlined,
  ListOutlined,
  Close,
  Timeline,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Drawer,
  IconButton,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { memo, useEffect, useMemo, useState } from "react";
import CardAlerts from "../sideBarEasyMaps/cardAlerts";
import ElementHeader from "../elementHeader";
import Detalhes from "./detalhes";
import { useNavigate, useOutletContext } from "react-router-dom";
import Conexao from "./conexoes";
import CardPotencia from "./cardPotencia";
import { useMapa } from "../../../contexts/mapaContext";
import useStyles from "./styles";
import VirtualizedAlerts from "../sideBarEasyMaps/cardAlerts/virtualizacao";

const RightBarEasyMaps = memo(
  ({
    element,
    iconsElement,
    setElement = () => {},
    fullScreem = false,
    link = "",
    setOpen = () => {},
    setFocusNodeId = () => {},
    openConnection,
    setOpenConnection = () => {},
    elementONUSelected,
    setElementONUSelected = () => {},
    setFocusedId = () => {},
    setOpenHistoryModal = () => {},
    setConnectionLocal,
    setHostParamModal,
  }) => {
    const { connections, hostsDataMap, alertsDataMap } = useMapa();
    const { id, titulo, elementConfig, img, tipo, mapRef, mapRefId } =
      element || {};
    const alerts = useMemo(
      () => alertsDataMap.get(id) || [],
      [alertsDataMap, id],
    );

    const [enlacesConectados, setEnlacesConectados] = useState([]);
    const [valueTab, setValueTab] = useState(1);
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(null);
    const [hosts, setHosts] = useState([]);
    const { configLayer } = useOutletContext();
    const [colorAlert, setColorAlert] = useState(null);
    const [snackbar, setSnackbar] = useState(null);

    const theme = useTheme();
    const styles = useStyles({ theme, fullScreem, colorAlert });

    const handleChangeTab = (event, newValue) => {
      if (newValue == 1 && element.tipoBgpIxc != null) {
        setElement((ele) => ({ ...ele }));
        setElementONUSelected(null);
      }
      setOpenConnection(null);
      setExpanded(null);
      setValueTab(newValue);
    };
    //pegar as conexões desse host
    useEffect(() => {
      if (!element || !connections) return;

      let enlaces = [...connections.values()].filter(
        ({ referenceId, destinationId }) =>
          id === destinationId || id === referenceId,
      );

      setEnlacesConectados(enlaces);
    }, [connections, element]);

    useEffect(() => {
      setValueTab(1);
    }, [element?.id]);

    useEffect(() => {
      if (element?.tipoBgpIxc != null) {
        if (elementONUSelected) {
          let index = element.elementsClients.findIndex(
            (en) => en.id == elementONUSelected.id,
          );
          setExpanded(index);
          setValueTab(2);
        } else {
          setExpanded(null);
        }
      } else {
        if (openConnection) setValueTab(3);
      }
    }, [enlacesConectados]);

    // agrupar as informações por host
    useEffect(() => {
      if (!element || !element.id) {
        return;
      }
      const hostsData = hostsDataMap.get(element.id) || [];
      setHosts(structuredClone(hostsData));
    }, [element]);

    function onClose() {
      setOpen(false);
      setExpanded(null);
      setOpenConnection(null);
      setFocusedId(null);
    }
    useEffect(() => {
      if (element === null) {
        onClose();
      }
    }, [element]);
    const handleMouseDown = (event) => {
      let url = `${window.location.origin}${link}`;
      if (event.button === 1) {
        window.open(url, "_blank");
      }
    };

    return (
      <>
        <Drawer
          open={!!element?.id}
          //onClose={onClose}
          onAbort={onClose}
          anchor="right"
          sx={styles.drawer}
          variant="persistent"
        >
          <Box>
            <Stack
              sx={{ paddingY: "12px" }}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 500,
                  //color: theme.palette.text.disabled,
                }}
              >
                {"Detalhes do " +
                  (tipo == 0 ? "Elemento" : tipo == 1 ? "Mapa" : "POP")}
              </Typography>
              <Stack gap={1} direction={"row"}>
                {tipo != 0 && (
                  <Tooltip title="ir para o mapa">
                    <IconButton
                      disabled={!mapRefId}
                      color="primary"
                      onMouseDown={handleMouseDown}
                      onClick={() => {
                        onClose();
                        setElement(null); // não remova
                        navigate(link);
                      }}
                    >
                      <LaunchOutlined sx={{ fontSize: "20px" }} />
                    </IconButton>
                  </Tooltip>
                )}
                <IconButton size="small" onClick={() => setElement(null)}>
                  <Close
                    sx={{
                      fontSize: "20px",
                      color: theme.palette.text.disabled,
                    }}
                  />
                </IconButton>
              </Stack>
            </Stack>

            <Stack sx={styles.card}>
              <Box sx={styles.line} />
              <ElementHeader
                mapa={mapRef}
                tipo={tipo}
                titulo={titulo}
                interfaces={
                  Array.isArray(elementConfig?.config?.hosts) &&
                  elementConfig?.config?.hosts?.length > 0
                    ? elementConfig?.config?.hosts[0]?.interfaces
                    : []
                }
                tags={
                  Array.isArray(elementConfig?.config?.hosts) &&
                  elementConfig?.config?.hosts?.length > 0
                    ? elementConfig?.config?.hosts[0]?.tags
                    : []
                }
                img={
                  iconsElement?.find((icon) => icon.id == img)?.img ||
                  iconsElement?.find(
                    (icon) =>
                      icon.nome ==
                      (element?.tipo === 0
                        ? "_roteador"
                        : element?.tipo === 1
                          ? "_mapa"
                          : "_pop"),
                  )?.img
                }
                setSnackbar={setSnackbar}
              />
            </Stack>
            <Stack sx={[styles.card, { p: 0.5, mt: 2, height: "50px" }]}>
              <Tabs
                variant="fullWidth"
                value={valueTab}
                onChange={handleChangeTab}
                textColor="primary"
                indicatorColor="primary"
                sx={styles.tabs}
              >
                <Tab
                  icon={valueTab == 1 ? <ListOutlined /> : null}
                  label="Detalhes"
                  value={1}
                  sx={styles.text}
                  iconPosition="start"
                />
                <Tab
                  icon={valueTab == 2 ? <BoltOutlined /> : null}
                  label="Alertas"
                  value={2}
                  sx={[
                    styles.text,
                    { "& .MuiTab-icon": { marginRight: "0px" } },
                  ]}
                  iconPosition="start"
                />
                <Tab
                  icon={valueTab == 3 ? <LinkOutlined /> : null}
                  label="Conexões"
                  value={3}
                  sx={styles.text}
                  iconPosition="start"
                />
              </Tabs>
            </Stack>

            <Stack sx={{ overflowY: "auto", flexGrow: 1, mt: 2, mb: 1 }}>
              {valueTab === 1 && (
                <Stack sx={styles.contentTab}>
                  {hosts?.map((host, index) => {
                    return (
                      <Detalhes
                        host={host}
                        key={index + "hostslist"}
                        unique={hosts.length == 1}
                        expanded={expanded}
                        setExpanded={setExpanded}
                        index={index}
                        setOpenHistoryModal={setOpenHistoryModal}
                        setConnectionLocal={setConnectionLocal}
                        setHostParamModal={setHostParamModal}
                      />
                    );
                  })}
                </Stack>
              )}
              {valueTab === 2 && (
                <Stack sx={styles.contentTab}>
                  <VirtualizedAlerts
                    alertasTotais={alerts}
                    style={styles.contentTab}
                    search={setFocusNodeId}
                  />
                </Stack>
              )}
              {valueTab === 3 && (
                <Stack sx={styles.contentTab}>
                  {enlacesConectados?.map((conn, index) => {
                    const isTrafego =
                      configLayer?.[element?.mapId] === "trafego" ||
                      !configLayer?.[element?.mapId];
                    const isPotencia =
                      configLayer?.[element?.mapId] === "potencia";
                    const isUnique = enlacesConectados.length === 1;

                    if (isTrafego) {
                      return (
                        <Conexao
                          key={`conn-${index}`}
                          conexao={conn}
                          element={element}
                          unique={isUnique}
                          expanded={openConnection}
                          setExpanded={setOpenConnection}
                          index={index}
                          setOpenHistoryModal={setOpenHistoryModal}
                          setConnectionLocal={setConnectionLocal}
                        />
                      );
                    }

                    if (isPotencia) {
                      return (
                        <CardPotencia
                          key={`connPot-${index}`}
                          conexao={conn}
                          element={element}
                          unique={isUnique}
                          expanded={expanded}
                          setExpanded={setExpanded}
                          index={index}
                          setOpenHistoryModal={setOpenHistoryModal}
                          setConnectionLocal={setConnectionLocal}
                        />
                      );
                    }
                  })}
                </Stack>
              )}
            </Stack>
          </Box>
        </Drawer>
        {!!snackbar && (
          <Snackbar
            open
            onClose={() => setSnackbar(null)}
            autoHideDuration={2000}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert {...snackbar} onClose={() => setSnackbar(null)} />
          </Snackbar>
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.openConnection === nextProps.openConnection &&
      prevProps.fullScreem === nextProps.fullScreem &&
      JSON.stringify(prevProps.element) === JSON.stringify(nextProps.element) &&
      JSON.stringify(prevProps.elementONUSelected) ===
        JSON.stringify(nextProps.elementONUSelected) &&
      JSON.stringify(prevProps.connections) ===
        JSON.stringify(nextProps.connections)
    );
  },
);

export default RightBarEasyMaps;
